var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5625 10.8379V16.4382C17.5622 16.7365 17.4436 17.0224 17.2327 17.2334C17.0218 17.4443 16.7358 17.5629 16.4375 17.5632H14.5625C14.3636 17.5632 14.1728 17.4842 14.0322 17.3435C13.8915 17.2029 13.8125 17.0121 13.8125 16.8132V14.7507C13.8125 14.6512 13.773 14.5558 13.7027 14.4855C13.6323 14.4152 13.537 14.3757 13.4375 14.3757H11.5625C11.463 14.3757 11.3677 14.4152 11.2973 14.4855C11.227 14.5558 11.1875 14.6512 11.1875 14.7507V16.8132C11.1875 17.0121 11.1085 17.2029 10.9678 17.3435C10.8272 17.4842 10.6364 17.5632 10.4375 17.5632H8.5625C8.26422 17.5629 7.97825 17.4443 7.76733 17.2334C7.55642 17.0224 7.4378 16.7365 7.4375 16.4382V10.8379C7.43778 10.7084 7.47143 10.5812 7.53522 10.4685C7.599 10.3557 7.69075 10.2614 7.80162 10.1944L12.1141 7.60694C12.2307 7.53696 12.3641 7.5 12.5001 7.5C12.6361 7.5 12.7695 7.53696 12.8861 7.60694L17.1986 10.1944C17.3094 10.2614 17.4011 10.3558 17.4649 10.4685C17.5286 10.5812 17.5622 10.7084 17.5625 10.8379Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1c099dc1e35681bb44d6467b77122c86.svg";
export { ForwardRef as ReactComponent };